import React from 'react';
import './Torneo.css';
import basket1 from './assets/basket1.jpg';
import basket2 from './assets/basket2.jpg';

function Torneo() {
  return (
    <div className="torneo-container">
      <h1 className="torneo-title">Torneo di Pallacanestro Universitario</h1>
      <p className="torneo-description">
        Il Torneo di Pallacanestro Universitario è un evento annuale che coinvolge le squadre di basket delle università italiane. Le squadre si sfidano in un formato a eliminazione diretta, con l'obiettivo di conquistare il titolo di campione nazionale universitario.
      </p>
      <div className="torneo-gallery">
        <img src={basket1} alt="Partita di basket 1" className="torneo-image" />
        <img src={basket2} alt="Partita di basket 2" className="torneo-image" />
      </div>
    </div>
  );
}

export default Torneo;
